export { default as PoliciesPage } from './PoliciesPage.vue'
export { default as PolicyEditPage } from './PolicyEditPage.vue'
export { default as PolicyEditBulkPage } from './PolicyEditBulkPage.vue'
